import React from 'react'
import './App.css'
import Home from './pages/home/Home'
import Login from './pages/login/Login'
import Category from './pages/category/Category'

import AddCategory from './pages/category/addcategory'
import EditCategory from './pages/category/editcategory'
import Order from './pages/order/Order'

import PrivateComponent from './components/PrivateComponents'
import Store from './pages/store/Store'
import AddStoreDetails from './pages/store/AddStoreDetails'
import EditStoreDetails from './pages/store/EditStoreDetails'
import AddStore from './pages/store/AddStore'
import EditStore from './pages/store/EditStore'
import Register from './pages/register/Register'
import Appointment from './pages/appointment/Appointment'
import Staff from './pages/staff/Staff'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import AddStaff from './pages/staff/addstaff'
import StaffEdit from './pages/staff/editstaff'

import { ThemeProvider, createTheme } from '@mui/material/styles'
import CategorySub from './pages/SubCategory/SubCategory'
import Products from './pages/products/Products'
import AddProducts from './pages/products/addProducts'
import ProductEdit from './pages/products/editProducts'
import Customer from './pages/customer/Customer'
import AddCustomer from './pages/customer/addCustomer'
import CustomerEdit from './pages/customer/editCustomer'
import ViewCustomer from './pages/customer/viewCustomer'
import Rate from './pages/rate/Rate'
import RateAdd from './pages/rate/addrate'
import RateEdit from './pages/rate/editrate'
import About from './pages/website/about/About'
import AddAbout from './pages/website/about/addabout'
import EditAbout from './pages/website/about/editabout'
import OptionList from './pages/website/optionlist/OptionList'
import AddOptionList from './pages/website/optionlist/addOptionList'
import OptionListEdit from './pages/website/optionlist/optionlistedit'
import Testimonials from './pages/website/testimonials/Testimonials'
import AddTestimonial from './pages/website/testimonials/addTestimonial'
import TestimonialsEdit from './pages/website/testimonials/testimoanialsedit'
import TryOn from './pages/website/tryon/TryOn'
import AddTryOn from './pages/website/tryon/addTryon'
import TryOnEdit from './pages/website/tryon/tryonedit'
import ProductStyle from './pages/productStyle/Productstyle'
import AddProductStyle from './pages/productStyle/addproductstyle'
import EditProdcutStyle from './pages/productStyle/editproductstyle'
import AddSubCategory from './pages/SubCategory/AddSubcategory'
import EditSubCategory from './pages/SubCategory/EditSubCategory'
import Banner from './pages/website/banner/Banner'
import BannerAdd from './pages/website/banner/addbanner'
import BannerEdit from './pages/website/banner/banneredit'
import Appointments from './pages/appointments'
import ViewAppointment from './pages/appointments/View'
import CustomRequest from './pages/customRequest'
import ViewCustomRequest from './pages/customRequest/viewCustomRequest'
import ContactUsList from './pages/contactUs'

function App() {
  const theme = createTheme()
  return (
    <div>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="register" element={<Register />} />
            <Route index element={<Login />} />
            <Route element={<PrivateComponent />}>
              <Route path="dashboard" element={<Home />} />
              <Route path="category" element={<Category />} />
              <Route path="product" element={<Products />} />
              <Route path="product/add" element={<AddProducts />} />
              <Route path="product/:id" element={<ProductEdit />} />

              <Route path="category/add" element={<AddCategory />} />
              <Route path="category/edit" element={<EditCategory />} />
              <Route path="order" element={<Order />} />

              {/* Customer Routes */}
              <Route path="customer" element={<Customer />} />
              <Route path="customer/add" element={<AddCustomer />} />
              <Route path="customer/edit" element={<CustomerEdit />} />
              <Route path="customer/edit/:editid" element={<CustomerEdit />} />
              <Route path="customer/view/:viewid" element={<ViewCustomer />} />

              {/* Store Routes */}
              <Route path="store" element={<Store />} />
              <Route path="addstoredetails" element={<AddStoreDetails />} />
              <Route
                path="editstoredetails/:id"
                element={<EditStoreDetails />}
              />
              <Route path="addstore" element={<AddStore />} />
              <Route path="editstore/:id" element={<EditStore />} />

              {/* Appointment Routes */}
              <Route path="appointment" element={<Appointment />} />
              <Route
                path="customrequest/view/:id"
                element={<ViewCustomRequest />}
              />

              {/* Custom Request Routes */}
              <Route path="customrequest" element={<CustomRequest />} />

              {/* Contactus list Request Routes */}
              <Route path="contactuslist" element={<ContactUsList />} />

              {/* Staff Routes */}
              <Route path="staff" element={<Staff />} />
              <Route path="staff/add" element={<AddStaff />} />
              <Route path="staff/edit" element={<StaffEdit />} />
              <Route path="staff/edit/:editid" element={<StaffEdit />} />

              {/* SubCategory Routes */}
              <Route path="subcategory" element={<CategorySub />} />
              <Route path="subcategory/add" element={<AddSubCategory />} />
              <Route path="subcategory/edit" element={<EditSubCategory />} />
              <Route
                path="subcategory/edit/:id"
                element={<EditSubCategory />}
              />

              <Route path="rate" element={<Rate />} />
              <Route path="rate/add" element={<RateAdd />} />
              <Route path="rate/edit" element={<RateEdit />} />
              <Route path="rates/edit/:id" element={<RateEdit />} />

              {/* About Routes*/}
              <Route path="about" element={<About />} />
              <Route path="about/add" element={<AddAbout />} />
              <Route path="about/edit" element={<EditAbout />} />
              <Route path="about/edit/:editid" element={<EditAbout />} />

              {/* Banner Routes */}
              <Route path="banner" element={<Banner />} />
              <Route path="sliders/add" element={<BannerAdd />} />
              <Route path="sliders/edit" element={<BannerEdit />} />
              <Route path="sliders/edit/:editid" element={<BannerEdit />} />

              {/* Option Routes */}
              <Route path="optionlist" element={<OptionList />} />
              <Route path="optionlist/add" element={<AddOptionList />} />
              <Route path="optionlist/edit/:id" element={<OptionListEdit />} />

              {/* Testimonial Routes */}
              <Route path="testimonial" element={<Testimonials />} />
              <Route path="testimonial/add" element={<AddTestimonial />} />
              <Route
                path="testimonial/edit/:editid"
                element={<TestimonialsEdit />}
              />
              {/* Product Style Routes */}
              <Route path="productstyle" element={<ProductStyle />} />
              <Route path="productstyle/add" element={<AddProductStyle />} />
              <Route path="productstyle/edit" element={<EditProdcutStyle />} />
              <Route
                path="productstyle/edit/:id"
                element={<EditProdcutStyle />}
              />
              {/* TryOn Routes  */}
              <Route path="tryon" element={<TryOn />} />
              <Route path="tryon/add" element={<AddTryOn />} />
              <Route path="tryon/edit/:id" element={<TryOnEdit />} />

              {/* Appointments routes */}
              <Route path="appointments" element={<Appointments />} />
              <Route
                path="appointment/:device/:id"
                element={<ViewAppointment />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  )
}

export default App
